import { getDashColor } from '../../styles'
import {
  GRAY_SCALE_04,
} from 'bd-web-components/src/utils/dash-colors'
import styled, { css } from 'styled-components'

interface ExceptionContainerProps {
  height: number
  margin: boolean
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1325px;
  margin: 0 auto;
  margin-bottom: 162px;
  padding: 0px 64px;
  @media (max-width: 768px) {
    padding: 0px 24px;
  }
`

export const MobileDesktopControl = styled.div`
  display: block;
  @media (max-width: 768px) {
    display: none;
  }
  &.mobile-only {
    display: none;

    @media (max-width: 768px) {
      display: block;
    }
  }
`

export const PageTitle = styled.h4`
  color: ${getDashColor('PRIMARY_BLUE_02', 'GRAY_DARK')};
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 35.2px; /* 110% */
  margin-bottom: 19px;
  @media (max-width: 768px) {
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px; /* 110% */
    margin-bottom: 13px;
  }
`
export const PageEventName = styled.h4`
  color: ${getDashColor('PRIMARY_BLUE_02', 'GRAY_DARK')};
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 35.2px; /* 110% */
  margin-bottom: 19px;
  @media (max-width: 768px) {
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px; /* 110% */
    margin-bottom: 13px;
  }
`

export const PageSubtitle = styled.p`
  color: ${getDashColor('GRAY_SCALE_05', 'GRAY_DARK')};
  opacity: 0.6;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  @media (max-width: 768px) {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`

export const FormDivider = styled.div`
  background-color: ${getDashColor('GRAY_SCALE_08', 'BEIGE')};
  width: 100%;
  height: 2px;
  margin-top: 29px;
  @media (max-width: 768px) {
    margin-top: 29px;
  }
`

export const Divider50 = styled.div`
  background-color: ${getDashColor('GRAY_SCALE_08', 'BEIGE')};
  width: 50%;
  height: 2px;
  margin: 24px 0;
  @media (max-width: 768px) {
    width: 100%;
  }
`

export const Divider25 = styled.div`
  background-color: ${getDashColor('GRAY_SCALE_08', 'BEIGE')};
  width: 25%;
  height: 2px;
  margin: 24px 0;
`

export const FirstStepButtonBox = styled.div`
  width: 200px;
`

export const TextHeaderBox = styled.div`
  width: 100%;
`

export const ExceptionContainer = styled(styled.div``) <ExceptionContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;

  ${(props) =>
    props.height !== undefined &&
    css`
      height: ${props.height}px;
    `}
  ${(props) =>
    props.margin &&
    css`
      margin-bottom: 100px;
    `}
`

export const ButtonDescription = styled.div`
  padding: 0 32px;
`

export const ContainerButtons = styled.div`
  display: flex;
`

export const ContainerCard = styled.div`
  width: 184px;
  margin-right: 8px;
  cursor: pointer;
  @media (max-width: 762px) {
    width: 100%;
  }
`

export const DetailCard = styled.div`
  display: flex;
  height: 58px;
  width: 184px;
  border: 1px solid ${getDashColor('GRAY_SCALE_09', 'BEIGE')};
  border-radius: 5px;
  padding: 30px;
  margin: 8px;

  @media (max-width: 762px) {
    width: 100%;
  }
`

export const LabelCard = styled.div`
  color: ${GRAY_SCALE_04};
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0px 8px;
`

export const IconDetailContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-around;
  &:before {
    content: '';
    width: 38px;
    height: 38px;
    background-color: ${getDashColor('SECONDARY_BLUE_10', 'SECONDARY_COLOR')};
    border-radius: 100px;
    position: absolute;
    z-index: 0;
  }
  & div {
    z-index: 1;
  }
`

export const BalanceAvailableButton = styled.div`
  max-width: 280px;
`

export const BalanceAvailable = styled.div`
  color: ${getDashColor('PRIMARY_BLUE_03', 'GRAY_DARK')};
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 35.2px;
  margin-top: 16px;
  max-width: 280px;
`

export const BalanceAvailableLabel = styled.div`
  color: ${getDashColor('PRIMARY_BLUE_07', 'GRAY_DARK')};
  opacity: 0.6;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22.4px;
  margin-top: 32px;
  margin-bottom: 16px;
  max-width: 280px;
  display: flex;
  justify-content: space-between;
`

export const BalanceAvailableIcon = styled.div`
  text-align: right;
  top: 25px;
  position: relative;
`

export const BalanceLabel = styled.div`
  display: flex;
  align-items: baseline;
  color: ${getDashColor('PRIMARY_BLUE_07', 'GRAY_DARK')};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 19.6px;
`

export const BalanceValue = styled.div`
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22.4px;
  margin-bottom: 24px;
  padding: 0 5px;
`

export const ButtonHeaderBox = styled.div`
  width: 30%;
  display: flex;
  justify-content: flex-end;
  @media (max-width: 768px) {
    width: 100%;
    max-width: 100%;
    justify-content: flex-start;
    margin-top: 25px;
  }
`
export const PageHeaderBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  width: 100%;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    max-width: 100%;
  }
`
